

















import Vue from 'vue';
import Component from 'vue-class-component';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

export const LEGAL_LINK_CLICKED_EVENT = 'brandhub-legal-link-clicked';

const FooterNavigationItemProps = Vue.extend({
  props: {
    linkUrl: String,
    linkTitle: String,
    linkText: String,
    linkTarget: String,
    legalActionName: String,
  },
});

@Component
export default class FooterNavigationItem extends FooterNavigationItemProps {
  onClick () {
    if (this.legalActionName) {
      window.dispatchEvent(new CustomEvent(LEGAL_LINK_CLICKED_EVENT, {
        detail: this.legalActionName,
      }));
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Footer Navigation', this.legalActionName);
    }
  }

  onItemClick (): void {
    if (this.linkUrl) {
      const link = this.linkUrl;
      const label = this.linkText;
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Footer Navigation', label, link);
    }
  }
}
